import { Application } from "@hotwired/stimulus"
import SalaryInputController from "../controllers/salary_input_controller"
import LocationTypeController from "../controllers/location_type_controller"
import IndustrySkillsController from "../controllers/industry_skills_controller"
import CurrencyInputController from "../controllers/currency_input_controller"
import ScoreAnimationController from "../controllers/score_animation_controller"
import UrlFormatController from "../controllers/url_format_controller"
import SkillsSelectController from "../controllers/skills_select_controller"
import SearchableSkillsController from "../controllers/searchable_skills_controller"
import DismissController from "../controllers/dismiss_controller"
import TeamMissionQuestionController from "../controllers/team_mission_question_controller"
import RightRoleCurrentQuestionController from "../controllers/right_role_current_question_controller"
import AllocationPieController from "../controllers/allocation_pie_controller"
import TeamMemberDragController from "../controllers/team_member_drag_controller"
import CareerPathStepsSortableController from "../controllers/career_path_steps_sortable_controller"
import StarRatingController from "../controllers/star_rating_controller"
import TagSelectorController from "../controllers/tag_selector_controller"
import ProductFinderController from "./product_finder_controller"
import ResumeAutofillController from "./resume_autofill_controller"
import ResumeUploadController from "./resume_upload_controller"

const application = Application.start()

// Configure Stimulus development experience
application.debug = true
window.Stimulus = application

application.register("salary-input", SalaryInputController)
application.register("location-type", LocationTypeController)
application.register("industry-skills", IndustrySkillsController)
application.register("currency-input", CurrencyInputController)
application.register("score-animation", ScoreAnimationController)
application.register("url-format", UrlFormatController)
application.register("skills-select", SkillsSelectController)
application.register("searchable-skills", SearchableSkillsController)
application.register("dismiss", DismissController)
application.register("team-mission-question", TeamMissionQuestionController)
application.register("right-role-current-question", RightRoleCurrentQuestionController)
application.register("allocation-pie", AllocationPieController)
application.register("team-member-drag", TeamMemberDragController)
application.register("career-path-steps-sortable", CareerPathStepsSortableController)
application.register("star-rating", StarRatingController)
application.register("tag-selector", TagSelectorController)
application.register("product-finder", ProductFinderController)
application.register("resume-autofill", ResumeAutofillController)
application.register("resume-upload", ResumeUploadController)

export { application }
